/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetControlByIdResponseDto,
  GetControlListParams,
  GetControlListResponseDto,
  GetControlParametersResponseDto,
  GetControlResultKpisResponseDto,
  GetControlStatsParams,
  GetControlStatsResponseDto,
  GetControlStatusesResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get a control by id
 */
export const getControlById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlByIdResponseDto>(
      {url: `/controls/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetControlByIdQueryKey = (id?: string,) => {
    return [`/controls/${id}`] as const;
    }

    
export const getGetControlByIdQueryOptions = <TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlById>>> = ({ signal }) => getControlById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getControlById>>>
export type GetControlByIdQueryError = null | null | null


export function useGetControlById<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlById>>,
          TError,
          Awaited<ReturnType<typeof getControlById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlById<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlById>>,
          TError,
          Awaited<ReturnType<typeof getControlById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlById<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a control by id
 */

export function useGetControlById<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetControlByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlById>>> = ({ signal }) => getControlById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getControlById>>>
export type GetControlByIdSuspenseQueryError = null | null | null


export function useGetControlByIdSuspense<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlByIdSuspense<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlByIdSuspense<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a control by id
 */

export function useGetControlByIdSuspense<TData = Awaited<ReturnType<typeof getControlById>>, TError = null | null | null>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getControlById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a control stats
 */
export const getControlStats = (
    id: string,
    params: GetControlStatsParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlStatsResponseDto>(
      {url: `/controls/${id}/stats`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetControlStatsQueryKey = (id?: string,
    params?: GetControlStatsParams,) => {
    return [`/controls/${id}/stats`, ...(params ? [params]: [])] as const;
    }

    
export const getGetControlStatsQueryOptions = <TData = Awaited<ReturnType<typeof getControlStats>>, TError = null | null>(id: string,
    params: GetControlStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStats>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlStatsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlStats>>> = ({ signal }) => getControlStats(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getControlStats>>>
export type GetControlStatsQueryError = null | null


export function useGetControlStats<TData = Awaited<ReturnType<typeof getControlStats>>, TError = null | null>(
 id: string,
    params: GetControlStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlStats>>,
          TError,
          Awaited<ReturnType<typeof getControlStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlStats<TData = Awaited<ReturnType<typeof getControlStats>>, TError = null | null>(
 id: string,
    params: GetControlStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlStats>>,
          TError,
          Awaited<ReturnType<typeof getControlStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlStats<TData = Awaited<ReturnType<typeof getControlStats>>, TError = null | null>(
 id: string,
    params: GetControlStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStats>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a control stats
 */

export function useGetControlStats<TData = Awaited<ReturnType<typeof getControlStats>>, TError = null | null>(
 id: string,
    params: GetControlStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStats>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlStatsQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a control parameters
 */
export const getControlParameters = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlParametersResponseDto>(
      {url: `/controls/${id}/parameters`, method: 'GET', signal
    },
      options);
    }
  

export const getGetControlParametersQueryKey = (id?: string,) => {
    return [`/controls/${id}/parameters`] as const;
    }

    
export const getGetControlParametersQueryOptions = <TData = Awaited<ReturnType<typeof getControlParameters>>, TError = null | null>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlParameters>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlParametersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlParameters>>> = ({ signal }) => getControlParameters(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlParameters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlParametersQueryResult = NonNullable<Awaited<ReturnType<typeof getControlParameters>>>
export type GetControlParametersQueryError = null | null


export function useGetControlParameters<TData = Awaited<ReturnType<typeof getControlParameters>>, TError = null | null>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlParameters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlParameters>>,
          TError,
          Awaited<ReturnType<typeof getControlParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlParameters<TData = Awaited<ReturnType<typeof getControlParameters>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlParameters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlParameters>>,
          TError,
          Awaited<ReturnType<typeof getControlParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlParameters<TData = Awaited<ReturnType<typeof getControlParameters>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlParameters>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a control parameters
 */

export function useGetControlParameters<TData = Awaited<ReturnType<typeof getControlParameters>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlParameters>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlParametersQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a control statuses
 */
export const getControlStatuses = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlStatusesResponseDto>(
      {url: `/controls/${id}/statuses`, method: 'GET', signal
    },
      options);
    }
  

export const getGetControlStatusesQueryKey = (id?: string,) => {
    return [`/controls/${id}/statuses`] as const;
    }

    
export const getGetControlStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getControlStatuses>>, TError = null | null>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStatuses>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlStatusesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlStatuses>>> = ({ signal }) => getControlStatuses(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getControlStatuses>>>
export type GetControlStatusesQueryError = null | null


export function useGetControlStatuses<TData = Awaited<ReturnType<typeof getControlStatuses>>, TError = null | null>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStatuses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlStatuses>>,
          TError,
          Awaited<ReturnType<typeof getControlStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlStatuses<TData = Awaited<ReturnType<typeof getControlStatuses>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStatuses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlStatuses>>,
          TError,
          Awaited<ReturnType<typeof getControlStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlStatuses<TData = Awaited<ReturnType<typeof getControlStatuses>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStatuses>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a control statuses
 */

export function useGetControlStatuses<TData = Awaited<ReturnType<typeof getControlStatuses>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlStatuses>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlStatusesQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get KPIs for a specific control result
 */
export const getKPIsForControlResult = (
    controlId: string,
    resultId: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultKpisResponseDto>(
      {url: `/controls/${controlId}/results/${resultId}/kpis`, method: 'GET', signal
    },
      options);
    }
  

export const getGetKPIsForControlResultQueryKey = (controlId?: string,
    resultId?: string,) => {
    return [`/controls/${controlId}/results/${resultId}/kpis`] as const;
    }

    
export const getGetKPIsForControlResultQueryOptions = <TData = Awaited<ReturnType<typeof getKPIsForControlResult>>, TError = null | null>(controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKPIsForControlResult>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetKPIsForControlResultQueryKey(controlId,resultId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getKPIsForControlResult>>> = ({ signal }) => getKPIsForControlResult(controlId,resultId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId && resultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getKPIsForControlResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetKPIsForControlResultQueryResult = NonNullable<Awaited<ReturnType<typeof getKPIsForControlResult>>>
export type GetKPIsForControlResultQueryError = null | null


export function useGetKPIsForControlResult<TData = Awaited<ReturnType<typeof getKPIsForControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKPIsForControlResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKPIsForControlResult>>,
          TError,
          Awaited<ReturnType<typeof getKPIsForControlResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKPIsForControlResult<TData = Awaited<ReturnType<typeof getKPIsForControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKPIsForControlResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKPIsForControlResult>>,
          TError,
          Awaited<ReturnType<typeof getKPIsForControlResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKPIsForControlResult<TData = Awaited<ReturnType<typeof getKPIsForControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKPIsForControlResult>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get KPIs for a specific control result
 */

export function useGetKPIsForControlResult<TData = Awaited<ReturnType<typeof getKPIsForControlResult>>, TError = null | null>(
 controlId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKPIsForControlResult>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetKPIsForControlResultQueryOptions(controlId,resultId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get control list
 */
export const getControlList = (
    params: GetControlListParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlListResponseDto>(
      {url: `/controls`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetControlListQueryKey = (params?: GetControlListParams,) => {
    return [`/controls`, ...(params ? [params]: [])] as const;
    }

    
export const getGetControlListQueryOptions = <TData = Awaited<ReturnType<typeof getControlList>>, TError = null>(params: GetControlListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlList>>> = ({ signal }) => getControlList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlListQueryResult = NonNullable<Awaited<ReturnType<typeof getControlList>>>
export type GetControlListQueryError = null


export function useGetControlList<TData = Awaited<ReturnType<typeof getControlList>>, TError = null>(
 params: GetControlListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlList>>,
          TError,
          Awaited<ReturnType<typeof getControlList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlList<TData = Awaited<ReturnType<typeof getControlList>>, TError = null>(
 params: GetControlListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlList>>,
          TError,
          Awaited<ReturnType<typeof getControlList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlList<TData = Awaited<ReturnType<typeof getControlList>>, TError = null>(
 params: GetControlListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get control list
 */

export function useGetControlList<TData = Awaited<ReturnType<typeof getControlList>>, TError = null>(
 params: GetControlListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlList>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



